import { PaymentSource } from "types/billing/PaymentSource";

// Is a saved payment source likely chargeable (safe to promote to primary)? Card: not past
// expiry. PayPal: always. Chargebee's real `status` isn't on the frontend type, so this is a
// proxy; odd cases fall through to the dunning path.
export function isLikelyChargeable(paymentSource: PaymentSource): boolean {
  if (paymentSource.type === "paypal") {
    return true;
  }
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth() + 1;
  const { year, month } = paymentSource.expiry;
  return year > currentYear || (year === currentYear && month >= currentMonth);
}
